<template>
  <div class="container-fluid terms">
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {
    };
  },
  created() {
    window.location.href = 'https://plantsss.com';
  },
};
</script>
